import { useParams } from 'react-router-dom';
import { Row } from 'antd';

import { MilesText } from 'components';

import { SnapIconStatuses } from './SnapIconStatuses';

import { snapStore } from '../../store';

export const Title = () => {
  const claimDetails = snapStore((state) => state.claimDetails);
  const escalateDetails = snapStore((state) => state.escalateDetails);
  const claimReferenceCode = snapStore((state) => state.claimReferenceCode);
  const snapBooleanStatuses = snapStore((state) => state.snapBooleanStatuses);
  const fraudSuspicionReason = snapStore((state) => state.fraudSuspicionReason);

  const { snapId } = useParams();

  return (
    <Row align='middle'>
      <MilesText
        size='xxl'
        className='font-medium mr-3'
      >
        Snap #
        {snapId}
      </MilesText>

      <SnapIconStatuses
        claimDetails={claimDetails}
        escalateDetails={escalateDetails}
        claimReferenceCode={claimReferenceCode}
        snapBooleanStatuses={snapBooleanStatuses}
        fraudSuspicionReason={fraudSuspicionReason}
      />
    </Row>
  );
};
